import { ReportDetails } from "../../../merchant/controlKitchenApi"
import { AxiosInstance } from "axios"
import {
    CheckInSummary,
    Purchase,
    PurchaseNumberOfTransactions,
    ReportNumberOfTransactions,
    ReportPosPurchase,
    ReportUsersSummary,
    UserInfo,
} from "./companyReportsHomeTypes"

export enum CompanyReportsHomeQuery {
    POS_PURCHASES_SUMMARY = "pos-purchases-summary",
    POS_NUMBER_OF_TRANSACTIONS = "pos-number-of-transactions",
    MEETING_SERVICE_PURCHASES = "meeting-service-purchases",
    MEETING_SERVICE_NUMBER_OF_TRANSACTIONS = "meeting-service-number-of-transactions",
    USERS_SUMMARY = "users-summary",
    CHECK_IN_SUMMARY = "check-in-summary",
}

type FetchHomeStatisticParams = Readonly<{
    companyId: number
    periodInDays: number
}>

export type FetchPosPurchaseSummaryResponse = Readonly<{
    reportDetails: ReportDetails
    reportSummary: ReportPosPurchase
    posPurchases: Purchase[]
}>

export async function fetchPosPurchaseSummary(
    { companyId, periodInDays }: FetchHomeStatisticParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchPosPurchaseSummaryResponse> {
    const url = `/companies/${companyId}/dashboard/posPurchases`

    const { data } = await axios.get(url, {
        params: { periodInDays },
        signal,
    })

    return data
}

export type FetchPosNumberOfTransactionsResponse = Readonly<{
    reportDetails: ReportDetails
    reportSummary: ReportNumberOfTransactions
    posPurchases: PurchaseNumberOfTransactions[]
}>

export async function fetchPosNumberOfTransactions(
    { companyId, periodInDays }: FetchHomeStatisticParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchPosNumberOfTransactionsResponse> {
    const url = `/companies/${companyId}/dashboard/pos/numberOfTransactions`

    const { data } = await axios.get(url, {
        params: { periodInDays },
        signal,
    })

    return data
}

export type FetchMeetingServicePurchasesResponse = Readonly<{
    reportDetails: ReportDetails
    reportSummary: ReportPosPurchase
    meetingServicePurchases: Purchase[]
}>

export async function fetchMeetingServicePurchases(
    { companyId, periodInDays }: FetchHomeStatisticParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMeetingServicePurchasesResponse> {
    const url = `/companies/${companyId}/dashboard/meetingService/purchases`

    const { data } = await axios.get(url, {
        params: { periodInDays },
        signal,
    })

    return data
}

export type FetchMeetingServiceNumberOfTransactionsResponse = Readonly<{
    reportDetails: ReportDetails
    reportSummary: ReportNumberOfTransactions
    meetingServicePurchases: PurchaseNumberOfTransactions[]
}>

export async function fetchMeetingServiceNumberOfTransactions(
    { companyId, periodInDays }: FetchHomeStatisticParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMeetingServiceNumberOfTransactionsResponse> {
    const url = `/companies/${companyId}/dashboard/meetingService/numberOfTransactions`

    const { data } = await axios.get(url, {
        params: { periodInDays },
        signal,
    })

    return data
}

export type FetchUsersSummaryResponse = Readonly<{
    reportDetails: ReportDetails
    reportSummary: ReportUsersSummary
    numberOfUsers: UserInfo[]
}>

export async function fetchUsersSummary(
    { companyId, periodInDays }: FetchHomeStatisticParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUsersSummaryResponse> {
    const url = `/companies/${companyId}/dashboard/health/numberOfUsers`

    const { data } = await axios.get(url, {
        params: { periodInDays },
        signal,
    })

    return data
}

export type FetchCheckInSummaryResponse = Readonly<{
    reportDetails: {
        reportTime: string
    }
    checkInSummary: CheckInSummary
}>

export async function fetchCheckInSummary(
    { companyId, periodInDays }: FetchHomeStatisticParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchCheckInSummaryResponse> {
    const url = `/companies/${companyId}/dashboard/health/checkIns`

    const { data } = await axios.get(url, {
        params: { periodInDays },
        signal,
    })

    return data
}
